import React, { useRef, useState } from 'react'
import {
  Table, Button, Divider, Popconfirm, Row, Col, Tag, Card, Input,
  Icon,
} from 'antd'
import { ButtonEx } from '../../styles/button.style'
import WrappedBrandProductForm from './BrandProductForm'
import { useDispatch, useSelector } from 'react-redux'
import {
  fetchBrandById,
  saveBrandBarcode,
  saveBrandGuideItem,
  updateBarcodeProduct
} from '../../modules/brand'
import { useDeepEffect } from '../../utils/hooks'
import { isEmpty } from 'lodash'
import AddProductFeatureModal from './AddProductFeatureModal'
import {
  deleteBarcodeBrand,
  saveBarcodeProductFeature
} from '../../modules/barcodeProduct'
import PreviewImage from '../../components/PreviewImage'
import BrandGuideItem from './BrandGuideItem'
import Highlighter from 'react-highlight-words'

const BrandProduct = ({ brandId }) => {
  const dispatch = useDispatch()
  let searchInput = useRef(null)
  const [visible, setVisible] = useState(false)
  const [visibleProductFeature, setVisibleProductFeature] = useState(false)
  const [visiblePreview, setVisiblePreview] = useState(false)
  const [visibleGuideItem, setVisibleGuideItem] = useState(false)
  const [previewImage, setPreviewImage] = useState(null)
  const [formData, setFormData] = useState({})
  const [searchText, setSearchText] = useState('')
  const [formProductFeatureData, setFormProductFeatureData] = useState({
    barcodeId: undefined,
    productFeaturesList: []
  })

  const { brandObj } = useSelector(
    (state) => ({
      brandObj: state.brand.brandObj
    }),
    []
  )

  async function fetchData() {
    await dispatch(fetchBrandById(brandId))
  }

  useDeepEffect(() => {
    if (brandId) {
      fetchData()
    }
  }, [brandId])


  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}>
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select())
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  })

  const handleSearch = (selectedKeys, confirm) => {
    confirm()
    setSearchText(selectedKeys[0])
  }

  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }

  const columns = [
    {
      title: 'รูป',
      dataIndex: 'image',
      key: 'image',
      render: (text, record) => (
        <a
          onClick={() => {
            setVisiblePreview(true)
            setPreviewImage(record.barcodeImage)
          }}>
          View
        </a>
      )
    },
    {
      title: 'Barcode',
      key: 'barcode',
      dataIndex: 'barcode',
      ...getColumnSearchProps('barcode'),
      render: (name, row) => (
        <div>
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={name.toString()}
          />
        </div>
      )
    },
    {
      title: 'Barcode Name',
      key: 'brand',
      dataIndex: 'barcodeName',
      ...getColumnSearchProps('barcodeName'),
      render: (name, row) => (
        <div>
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={name.toString()}
          />
        </div>
      )
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status'
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <span>
          {!isEmpty(record.brandGuideItemList) ? (
            <Button
              type="primary"
              size="small"
              shape="circle"
              icon="edit"
              onClick={(e) => onEditGuideItem(e, record)}
            />
          ) : (
            <ButtonEx
              onClick={(e) => onEditGuideItem(e, record)}
              color="#6ebf4b"
              type="primary"
              size="small"
              shape="circle"
              icon="plus"
            />
          )}
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.barcodeId)}>
            <Button type="danger" size="small" shape="circle" icon="delete" />
          </Popconfirm>
        </span>
      )
    }
  ]

  const onClick = (e) => {
    e.preventDefault()
    setVisible(true)
  }

  const onCloseModal = () => {
    setVisible(false)
  }

  const onOk = async (barcodeIds) => {
    setVisible(false)
    const data = {
      brandId: brandId,
      barcodeIds: barcodeIds
    }
    await dispatch(saveBrandBarcode(data))
    await dispatch(fetchBrandById(brandId))
  }

  const onDelete = async (barcodeId) => {
    await dispatch(deleteBarcodeBrand(barcodeId))
    await dispatch(fetchBrandById(brandId))
  }

  async function onEditGuideItem(e, record) {
    e.preventDefault()
    setVisibleGuideItem(true)
    setFormData(record)
  }

  async function onOkGuideItem(data, productData) {
    await setVisibleGuideItem(false)
    await dispatch(saveBrandGuideItem(data, formData.barcodeId))
    await dispatch(updateBarcodeProduct(productData))
    await dispatch(fetchBrandById(brandId))
    await setFormData({})
  }

  async function onCloseModalGuideItem() {
    setVisibleGuideItem(false)
    // setFormProductFeatureData(initialState)
  }

  async function onEditProductFeatures(e, record) {
    e.preventDefault()
    setVisibleProductFeature(true)
    setFormProductFeatureData((prevState) => {
      prevState.barcodeId = record.barcodeId
      prevState.productFeaturesList = record.productFeatureList
      return prevState
    })
  }

  async function onOkModalProductFeature() {
    const data = {
      barcodeId: formProductFeatureData.barcodeId,
      productFeatureIds: formProductFeatureData.productFeaturesList.map(
        (item) => item.id
      )
    }
    await dispatch(saveBarcodeProductFeature(data))
    await dispatch(fetchBrandById(brandId))
    await setVisibleProductFeature(false)
  }

  async function onCloseModalProductFeature() {
    setVisibleProductFeature(false)
    // setFormProductFeatureData(initialState)
  }

  function getDefaultExpand(barcodeList) {
    const arr = []

    for (const item of barcodeList) {
      if (!isEmpty(item.productFeatureList)) {
        arr.push(item.barcodeId)
      }
    }

    return arr
  }

  const HeaderProductFeature = (record) => {
    return (
      <Row type="flex" justify="space-between">
        <Col>
          <span>Product Features</span>
        </Col>
        <Col>
          <Button
            type="primary"
            onClick={(e) => onEditProductFeatures(e, record)}>
            {!isEmpty(record.productFeatureList) ? 'Edit' : 'Add'} Product
            Feature
          </Button>
        </Col>
      </Row>
    )
  }

  return (
    <Card
      title="Brand Product"
      extra={<Row type="flex">
        <Col span={12}>
        </Col>
        <Col span={12}>
          <Row type="flex" justify="end">
            <ButtonEx
              color="#6ebf4b"
              type="primary"
              onClick={(e) => onClick(e)}>
              เพิ่มสินค้า
            </ButtonEx>
          </Row>
        </Col>
      </Row>}>
      {!isEmpty(brandObj) && (
        <Table
          rowKey={(record) => {
            return record.barcodeId
          }}
          bordered
          dataSource={brandObj.barcodeList}
          columns={columns}
          defaultExpandedRowKeys={getDefaultExpand(brandObj.barcodeList)}
          expandedRowRender={(record) => (
            <Card title={HeaderProductFeature(record)}>
              <Row gutter={8} type="flex">
                {record.productFeatureList.map((item, index) => {
                  return (
                    <Col key={index}>
                      <Tag color="green">
                        <img src={item.badge} alt="" width={16} height={16} />
                        <span style={{ marginLeft: '5px' }}>{item.detail}</span>
                      </Tag>
                    </Col>
                  )
                })}
              </Row>
            </Card>
          )}
        // pagination={{
        //   current: barcodeProductObj.pageable.pageNumber + 1,
        //   pageSize: barcodeProductObj.size,
        //   pageSizeOptions: ['10', '20', '50', '100'],
        //   showSizeChanger: true,
        //   onShowSizeChange: onShowSizeChange,
        //   onChange: onChange,
        //   total: barcodeProductObj.totalElements
        // }}
        />
      )}
      <BrandGuideItem
        formData={formData}
        visible={visibleGuideItem}
        onOk={onOkGuideItem}
        onCancel={onCloseModalGuideItem}
      />
      <PreviewImage
        imgUrl={previewImage}
        visible={visiblePreview}
        onClose={() => {
          setVisiblePreview(false)
          setPreviewImage(null)
        }}
      />
      <WrappedBrandProductForm
        visible={visible}
        formData={formData}
        onOk={onOk}
        onCancel={onCloseModal}
      />
      <AddProductFeatureModal
        formData={formProductFeatureData}
        setFormProductFeatureData={setFormProductFeatureData}
        visible={visibleProductFeature}
        onOk={onOkModalProductFeature}
        onCancel={onCloseModalProductFeature}
      />
    </Card>
  )
}

export default BrandProduct



// WEBPACK FOOTER //
// ./src/pages/BrandProduct/index.js